module.exports = __webpack_public_path__ + "static/media/logo-vigdis-white-is.70ee28f6.png";